<div fxLayout="column" [style.height]="height" [style.width]="width">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div *ngIf="label" class="input-label">{{ label }}</div>
    <div class="input-label" *ngIf="withSelector">Priorité</div>
  </div>
  <div [fxLayout]="layout" [fxLayoutAlign]="layoutAlign" style="height: 100%; width: 100%">
    <div *ngIf="withSelector">
      <div
        *ngFor="let element of elements"
        class="check-box-sel"
        fxLayout="row wrap"
        fxLayoutAlign="space-between center"
        [style.gap]="gap"
      >
        <button
          class="mat-flat-button"
          mat-flat-button
          [disabled]="element?.isDisabled"
          (click)="element.isChecked = !element?.isChecked; changeSelection()"
          [class.checked]="element?.isChecked"
        >
          {{ element?.label }}
        </button>
        <app-text-input
          [(inputModel)]="element.priority"
          [initInput]="$any(element?.priority)"
          type="number"
          [showNumberButtons]="true"
          [minNumber]="1"
          [maxNumber]="99"
          *ngIf="element?.isChecked"
          (inputModelChange)="changeSelection()"
        ></app-text-input>
      </div>
    </div>
    <div
      *ngIf="!withSelector"
      [fxLayout]="layout"
      [fxLayoutAlign]="layoutAlign"
      [style.gap]="gap"
      style="height: 100%; width: 100%"
    >
      <button
        class="mat-flat-button"
        *ngIf="maintainTeams"
        (click)="selectAll()"
        [class.checked]="isAllSelected(elements)"
      >
        Tout sélectionner
      </button>

      <button
        class="mat-flat-button"
        *ngIf="selectAllOption"
        (click)="selectAll()"
        [class.checked]="isAllSelected(elements)"
      >
        Tout sélectionner
      </button>

      <button
        class="mat-flat-button"
        mat-flat-button
        *ngFor="let element of elements"
        [disabled]="element?.isDisabled"
        (click)="selectElement(element); changeSelection()"
        [class.checked]="element?.isChecked"
      >
        {{ element?.label }}
      </button>
    </div>
  </div>
  <div class="input-hint-message" *ngIf="hintMessage.length > 0">{{ hintMessage }}</div>
</div>
